import { Component, Input } from '@angular/core';

import { ValidationError } from 'app/models';

@Component({
  selector: 'validationerrors',
  templateUrl: './validationerrors.component.html',
  styleUrls: ['./validationerrors.component.scss']
})
export class ValidationErrorsComponent {
  @Input() validationerrors: ValidationError[];
}



// WEBPACK FOOTER //
// ./src/app/shared/validationerrors/validationerrors.component.ts